/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * moovy-saas-api
 * OpenAPI spec version: 1.0.0
 */

export type HlsStatus = (typeof HlsStatus)[keyof typeof HlsStatus]

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const HlsStatus = {
  NONE: 'NONE',
  PROCESSING: 'PROCESSING',
  READY: 'READY',
  FAILED: 'FAILED',
} as const
